import { useState, useEffect, useCallback, useMemo } from 'react';
import { useI18n } from '../i18n';

const FALLBACK_LORE = ['...'];

/**
 * Hook para gestionar los mensajes de 'Lore' durante las pantallas de carga.
 * Preparado para futura integración con backend (RAG/Gemini).
 */
export default function useLoadingLore(isLoading) {
  const { language, t } = useI18n();
  const [index, setIndex] = useState(0);
  const loreMessages = useMemo(() => {
    const translated = t('mentalLoad.lore');
    return Array.isArray(translated) && translated.length ? translated : FALLBACK_LORE;
  }, [t]);

  const rotateLore = useCallback(() => {
    setIndex((prevIndex) => {
      if (loreMessages.length <= 1) return 0;
      let nextIndex = Math.floor(Math.random() * loreMessages.length);
      // Evitar repetir el mismo mensaje consecutivamente
      while (nextIndex === prevIndex) {
        nextIndex = Math.floor(Math.random() * loreMessages.length);
      }
      return nextIndex;
    });
  }, [loreMessages.length]);

  useEffect(() => {
    if (!isLoading) return;

    const interval = setInterval(() => {
      rotateLore();
    }, 4000); // Rotación cada 4 segundos

    return () => clearInterval(interval);
  }, [isLoading, rotateLore]);

  useEffect(() => {
    setIndex(0);
  }, [language]);

  // Aquí se podría añadir un useEffect adicional para cargar mensajes desde el backend
  // basado en qProfileParams si fuera necesario en el futuro.

  return loreMessages[index] || loreMessages[0] || '';
}
